<template>
	<div>
		<el-row>
			<el-col :span="16" class="left-breadcrumb">
				<el-breadcrumb separator="/">
					<el-breadcrumb-item>缺陷筛查</el-breadcrumb-item>
					<el-breadcrumb-item>工单列表</el-breadcrumb-item>
					<el-breadcrumb-item>工艺信息</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
			<el-col :span="8" class="right-actions">
				<el-tooltip class="item" effect="dark" content="返回工单列表" placement="left">
					<el-button icon="el-icon-arrow-left" @click="back" circle></el-button>
				</el-tooltip>
			</el-col>
		</el-row>

		<div class="craft-info">
			<el-row>
				<el-col :span="8"> 工单号：{{ work_order_code }} </el-col>
				<el-col :span="8"> 车间：{{ work_shopName }}，机台：{{ jt_name }} </el-col>
				<el-col :span="8"> 总长度：{{ total_len }}米 </el-col>
			</el-row>
		</div>
		<div>
			<div id="myChart" :style="{ height: '550px' }" v-loading="loading" :element-loading-text="loadingText"></div>
		</div>
	</div>
</template>

<script>
	import { getTechStatByJobOrderId } from '@/service/reportService'
	import { jtInfoRequest } from '@/network/requests/jtInfo'
	import { jobOrderRequest } from '@/network/requests/jobOrder'
	import { workshopRequest } from '@/network/requests/workshop'
	import { $in, like } from '@/network/util/QueryBuilder'

	export default {
		components: {},
		data() {
			return {
				jt_name: '',
				work_shopName: '',
				total_len: '...',
				work_order_code: '',
				loading: false,
				loadingText: '',
				chart: null,
				option: {
					color: ['#e43c59', '#a6e4a5', '#4eaddf', '#fdb86b', '#b400ff', '#2f4554', '#61a0a8'],
					title: { text: '良率-工艺参数', subtext: '良率-工艺参数统计图', left: 'center' },
					grid: {
						top: 80,
						left: 0,
						right: 0,
						bottom: 50,
						containLabel: true,
					},
					toolbox: { feature: { dataZoom: { yAxisIndex: 'none' }, restore: {}, saveAsImage: {} } },
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'cross',
							animation: false,
							label: { backgroundColor: '#505765' },
						},
						formatter(params) {
							var tips = [`位置：${params[0].axisValue} 米`]
							params.forEach(p => {
								if (p.seriesName == '良率' || p.seriesName == '米数') {
									tips.push(p.marker + '' + p.seriesName + ' ' + p.value)
								} else {
									tips.push(p.marker + '' + p.seriesName + ' ' + p.value + '，原始值：' + p.data.original)
								}
							})

							return tips.join('<br/>')
						},
					},
					legend: { data: [], left: 0 },
					dataZoom: [
						{
							show: true,
							realtime: true,
							start: 65,
							end: 85,
						},
						{
							type: 'inside',
							realtime: true,
							start: 65,
							end: 85,
						},
					],
					xAxis: [
						{
							type: 'category',
							boundaryGap: false,
							axisLine: { onZero: false },
							data: [],
						},
					],
					yAxis: [
						{
							name: '良率',
							type: 'value',
							min: 0,
							max: 1,
							interval: 0.1,
							axisLabel: {
								formatter: function(val) {
									return val * 100 + '%'
								},
							},
							axisPointer: {
								label: {
									formatter: function(params) {
										return (params.value * 100).toFixed(2) + '%'
									},
								},
							},
						},
						{
							name: '工艺参数值',
							type: 'value',
							min: 0,
							max: 100,
						},
					],
					series: [],
				},
			}
		},
		computed: {
			/**
			 * 批次Id。
			 */
			id() {
				return this.$route.query.id
			},
		},
		methods: {
			back() {
				this.$router.go(-1)
			},
			statCallback(text) {
				this.loadingText = text
			},
			chartTableToData(data) {
				var reuslt = []
				var properties = []
				var meters = []
				data.forEach(t => {
					for (var p in t) {
						if (p in properties == false) {
							properties.push(p)
						}
					}
				})

				properties = [...new Set(properties)]

				//data.forEach(t => {})
				var rates = []
				var legendData = []
				var series = []
				properties.forEach(p => {
					if (p == '米数') {
						meters = data.map(t => t[p])
					} else {
						var values = data.map(t => t[p])
						var yIndex = 1
						console.log(p)
						if (p == '良率') {
							yIndex = 0
						}

						series.push({
							name: p,
							type: 'line',
							animation: false,
							smooth: true,
							yAxisIndex: yIndex,
							lineStyle: { width: 1 },
							data: values,
							tooltip: {
								formatter(params) {
									console.log('tooltip', params)
									if (params.data.original) {
										return params.data.original
									} else if (params.data.value) {
										return params.data.value
									} else {
										return params.data
									}
								},
							},
						})

						legendData.push(p)
					}
				})

				this.option.legend.data = legendData
				this.option.xAxis[0].data = meters
				this.option.series = series

				// 绘制图表
				this.chart.setOption(this.option)
			},
		},
		mounted() {
			// 基于准备好的dom，初始化echarts实例
			this.chart = this.$echarts.init(document.getElementById('myChart'))

			window.addEventListener('resize', () => {
				this.chart.resize()
			})
		},
		async created() {
			this.loading = true
			//查询工单信息。
			var job_order_info = null
			try {
				job_order_info = (await jobOrderRequest.getDocumentById(this.id)).data
				//指定工单号。
				this.work_order_code = job_order_info.code
			} catch (err) {
				this.$message.error('工单信息查询出错：' + err.message)
			}

			var jt_info = null
			if (job_order_info) {
				//获取机台信息。
				try {
					jt_info = (await jtInfoRequest.getDocumentById(job_order_info.jt_id)).data
					this.jt_name = jt_info.name
				} catch (err) {
					this.$message.error('查询机台出错：' + err.message)
				}
			}

			var workshop = null
			if (jt_info) {
				try {
					//车间信息。
					workshop = (await workshopRequest.getDocumentById(jt_info.workshop_id)).data
					this.work_shopName = workshop.name
				} catch (err) {
					this.$message.error('查询车间信息出错：' + err.message)
				}
			}

			//查询批次的工艺统计信息。
			getTechStatByJobOrderId(this.id, this.statCallback)
				.then(res => {
					console.log('工艺参数统计', res)
					this.chartTableToData(res.chartData.rows)

					//工单总长度，由工单批次长度的和构成。
					this.total_len = res.totalLen / 1000
				})
				.catch(err => {
					console.log(err)
					this.$message.error('批次工艺信息数据查询出错：' + err.message)
				})
				.finally(() => {
					this.loading = false
				})
		},
	}
</script>

<style scoped>
	.craft-info {
		padding: 30px 20px;
		background-color: #f3f3f3;
		margin: 30px 0;
		border-radius: 4px;
	}
</style>
